import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter, statusList } from './BankKurbanUIHelpers';

import { toAbsoluteUrl } from '../../../../../_metronic/_helpers';

const BankKurbanUIContext = createContext();

export function useBankKurbanUIContext() {
    return useContext(BankKurbanUIContext);
}

export const BankKurbanUIConsumer = BankKurbanUIContext.Consumer;

export function BankKurbanUIProvider({ bankKurbanUIEvents, children }) {

    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [ids, setIds] = useState([]);
    const setQueryParams = useCallback((nextQueryParams) => {
        setQueryParamsBase((prevQueryParams) => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);
    const downloadTemplate = () => {
        window.open('https://docs.google.com/spreadsheets/d/1lXal6p9U22BZLiHI2jEquhXC0TpG0vEvZ811jodZQb8/edit?usp=sharing')
    }

    const value = {
        queryParams,
        setQueryParamsBase,
        ids,
        setIds,
        setQueryParams,
        newBankKurbanButtonClick: bankKurbanUIEvents.newBankKurbanButtonClick,
        openProcessPage: bankKurbanUIEvents.openProcessPage,
        downloadTemplate,
        statusList

    };

    return (
        <BankKurbanUIContext.Provider value={value}>
            {children}
        </BankKurbanUIContext.Provider>
    );
}
